"use client";

import { ElfsightWidget } from "react-elfsight-widget";
import StyledContainer from "@/components/StyledContainer";

const Reviews = ({ slice }) => {
  return (
    <StyledContainer slice={slice}>
      <ElfsightWidget widgetId="c28930bd-3526-4aae-9bba-b459882625c9" />
    </StyledContainer>
  );
};

export default Reviews;
